import AbstractLayer from './AbstractLayer';

interface IMapboxRasterLayerProps {
  map: any;
  layer: any;
}

export default class MapboxRasterLayer extends AbstractLayer {
  public props: IMapboxRasterLayerProps;
  public componentDidMount() {
    const { layer, map } = this.props;
    const mapboxLayerId = this.createMapboxId();
    const layerStyle = {
      'id': mapboxLayerId,
      'type': 'raster',
      'source': {
        'type': 'raster',
        'url': `mapbox://${layer.source}`,
      },
      'layout': {
        visibility: layer.visible ? 'visible' : 'none',
      },
      'paint': {
        'raster-opacity': 1
      }
    };

    map.addLayer(layerStyle);
    layer.connectMapbox(mapboxLayerId, map);
  }

  public render() {
    return  null;
  }
}
